export const dateParse = (date, timestamp = false) => {
  let ms = Date.parse(date) / 1000;

  return timestamp ? ms : ts2Date(ms);
};

export const toMilliseconds = (date) => {
  const newdate = new Date(date);

  return new Date().getTime() - newdate.getTime();
};

export const getArrivedTime = (createdAt) => {
  if (!createdAt) return "";

  const milliseconds = toMilliseconds(createdAt);
  var temp = Math.floor(milliseconds / 1000);
  var days = Math.floor((temp %= 31536000) / 86400);

  if (days) {
    return dateParse(createdAt).replace(" ", " (") + ")";
  }

  return `Chegou ${millisecondsToStr(milliseconds)}`;
};

export const millisecondsToStr = (milliseconds) => {
  function numberEnding(number) {
    return number > 1 ? "s" : "";
  }

  var temp = Math.floor(milliseconds / 1000);
  var days = Math.floor((temp %= 31536000) / 86400);
  var hours = Math.floor((temp %= 86400) / 3600);
  var minutes = Math.floor((temp %= 3600) / 60);
  var seconds = temp % 60;

  if (days) {
    return `${days} dia${numberEnding(days)} atrás`;
  }
  if (hours) {
    return `${hours} hora${numberEnding(hours)} atrás`;
  }
  if (minutes) {
    return `${minutes} minuto${numberEnding(minutes)} atrás`;
  }
  if (seconds) {
    return `${seconds} segundo${numberEnding(seconds)} atrás`;
  }

  return "há menos de um segundo";
};

export const convertMoney = (value, prefix = "R$", suffix = "") => {
  let numberFormater = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
  });

  return `${prefix} ${numberFormater.format((+value).toFixed(2))}${
    suffix ? " " + suffix : ""
  }`;
};

export const ts2Date = (iTimestamp, time = true) => {
  let options;
  let date = new Date(iTimestamp * 1000);

  if (time) {
    options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };
  } else {
    options = { year: "numeric", month: "2-digit", day: "2-digit" };
  }

  return date.toLocaleDateString("pt-BR", options);
};

/* Converte formato  AAAA-MM-DD para DD/MM/AAAA */
export const db2date = (sDate) => {
  return sDate.split("-").reverse().join("/");
};

export const validateTime = (e) => {
  if (Array.isArray(e)) {
    return e.map((item) => {
      item = String(item).replace(":", "");
      return `${item[0] + item[1]}:${item[2] + item[3]}`;
    });
  }

  return [];
};

export const iso2LocaleTime = (date) => {
 return date.toLocaleTimeString('default', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export const iso2LocaleDate = (date) => {
  return date.toLocaleDateString()
 }